const normalizeAutomationsPane = (value) => {
  const normalizedValue = String(value || '')
    .trim()
    .toLowerCase();

  if (normalizedValue === 'triggers') {
    return 'triggers';
  }

  if (normalizedValue === 'workflows') {
    return 'workflows';
  }

  return 'schedules';
};

const resolveAutomationsPane = ({ activeAutomationsPane = 'schedules', automationsRouteType = '', isCanonicalAutomationsView = false, isAutomationsView = false } = {}) => {
  const normalizedRouteType = String(automationsRouteType || '')
    .trim()
    .toLowerCase();

  if (isCanonicalAutomationsView && normalizedRouteType) {
    return normalizeAutomationsPane(normalizedRouteType);
  }

  if (!isAutomationsView) {
    return normalizeAutomationsPane(activeAutomationsPane);
  }

  return normalizeAutomationsPane(activeAutomationsPane);
};

export default resolveAutomationsPane;
